import { watch } from 'vue'
import { createI18n } from 'vue-i18n'
import { setDialectMaps } from '~/components/Utilities/languages/dialects'

const DEFAULT_LOCALE = 'en'
const localeLoaders = import.meta.glob('~~/locales/*.json')

async function loadLocaleMessages(locale) {
  const loaderKey = Object.keys(localeLoaders).find((path) =>
    path.endsWith(`/${locale}.json`)
  )
  if (!loaderKey) return null
  const module = await localeLoaders[loaderKey]()
  return module.default || module
}

export default defineNuxtPlugin(async (nuxtApp) => {
  const { vueApp } = nuxtApp
  const savedLanguage = import.meta.client
    ? localStorage.getItem('selectedLanguage')
    : null
  let initialLocale = savedLanguage || DEFAULT_LOCALE
  let initialMessages = await loadLocaleMessages(initialLocale)
  if (!initialMessages) {
    initialLocale = DEFAULT_LOCALE
    initialMessages = (await loadLocaleMessages(DEFAULT_LOCALE)) || {}
  }

  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: initialLocale,
    messages: {
      [initialLocale]: initialMessages,
    },
  })

  setDialectMaps(initialMessages.dialects)

  vueApp.use(i18n)
  nuxtApp.provide('i18n', i18n.global)

  const loadedLocales = new Set([initialLocale])
  watch(
    () => i18n.global.locale.value,
    async (locale) => {
      if (!loadedLocales.has(locale)) {
        const messages = await loadLocaleMessages(locale)
        if (!messages) return
        i18n.global.setLocaleMessage(locale, messages)
        loadedLocales.add(locale)
      }
      const localeMessages = i18n.global.getLocaleMessage(locale) || {}
      setDialectMaps(localeMessages.dialects)
    }
  )
})
